import React, { useState } from "react";

export default function ContactForm() {
  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // Your Formspree endpoint here!
  const FORMSPREE_URL = "https://formspree.io/f/manbplry"; // replace with your ID

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("Sending...");
    const form = e.target;
    const data = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
    };
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(data),
      });
      if (res.ok) {
        setSubmitted(true);
        setStatus("");
        form.reset();
      } else {
        setStatus("Sorry, there was a problem sending your message.");
      }
    } catch (err) {
      setStatus("Sorry, there was a problem sending your message.");
    }
  }

  if (submitted) {
    return (
      <div style={{
        maxWidth: 540, margin: "0 auto",
        background: "#fff", borderRadius: 18, boxShadow: "0 4px 24px rgba(120, 80, 160, 0.09)",
        padding: "2.1rem 2rem", textAlign: "center", color: "#6d3dc6", fontSize: "1.24rem"
      }}>
        <strong>Thank you!</strong><br />
        Your message has been sent.<br />
        We appreciate you reaching out to the family.
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="guestbook-form" style={{ maxWidth: 540, margin: "0 auto" }}>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="contact-name" style={{ fontWeight: 600, color: "#6d3dc6", marginBottom: 4, display: "block" }}>
          Your Name
        </label>
        <input
          id="contact-name"
          type="text"
          name="name"
          required
          style={{
            marginTop: 7,
            fontSize: "1.1rem",
            fontFamily: "inherit",
            background: "#f9f6fd",
            border: "1.5px solid #d1c4e9",
            borderRadius: "0.7rem",
            padding: "0.7rem 1rem",
            width: "100%",
          }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="contact-email" style={{ fontWeight: 600, color: "#6d3dc6", marginBottom: 4, display: "block" }}>
          Your Email
        </label>
        <input
          id="contact-email"
          type="email"
          name="email"
          required
          style={{
            marginTop: 7,
            fontSize: "1.1rem",
            fontFamily: "inherit",
            background: "#f9f6fd",
            border: "1.5px solid #d1c4e9",
            borderRadius: "0.7rem",
            padding: "0.7rem 1rem",
            width: "100%",
          }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="contact-message" style={{ fontWeight: 600, color: "#6d3dc6", marginBottom: 4, display: "block" }}>
          Your Message
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          style={{
            marginTop: 7,
            fontSize: "1.1rem",
            fontFamily: "inherit",
            background: "#f9f6fd",
            border: "1.5px solid #d1c4e9",
            borderRadius: "0.7rem",
            padding: "0.7rem 1rem",
            minHeight: 120,
            width: "100%",
            resize: "vertical",
          }}
        />
      </div>
      <button
        type="submit"
        style={{
          background: "#a78bfa",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "1.07rem",
          border: "none",
          borderRadius: "0.7rem",
          padding: "0.7rem 1.2rem",
          cursor: "pointer",
          marginTop: 16,
          width: "100%",
          boxShadow: "0 2px 10px rgba(80,64,120,0.09)",
          transition: "background 0.16s",
        }}
        onMouseOver={e => e.target.style.background = "#5e3694"}
        onMouseOut={e => e.target.style.background = "#a78bfa"}
      >
        Send Message
      </button>
      {status && (
        <div style={{ marginTop: 10, color: "#6d3dc6" }}>
          {status}
        </div>
      )}
    </form>
  );
}
